const stepsContainer = $('#stepsContainer').children();

window.trackSteps = function (step) {
  let i;
  for (i = 0; i < stepsContainer.length; i++) {
    if (step === i) {
      $(stepsContainer[i]).addClass('active');
      $(stepsContainer[i]).siblings().removeClass('active');
      if (step !== 0) {
        $(stepsContainer[i - 1]).addClass('done');
        $(stepsContainer[i - 1]).addClass('completed').html('<i class="fa fa-check-circle" aria-hidden="true"></i>');
      }
      break;
    }
  }
};
